var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("span", { staticClass: "text-uppercase field-label" }, [
        _vm._v(
          _vm._s(
            _vm.deliverableContactsLabel(
              _vm.deliverable.deliverable_template_id
            )
          )
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "info-bubbles exclude-outside-click",
          on: { click: _vm.showAddContact }
        },
        [
          _vm._l(_vm.deliverable.contacts, function(fieldValue, index) {
            return index <= 3
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover.html",
                        modifiers: { hover: true, html: true }
                      }
                    ],
                    key: "fieldValue" + index,
                    staticClass:
                      "initials badge badge-primary exclude-outside-click",
                    attrs: {
                      title:
                        index < 3
                          ? fieldValue.name
                          : _vm.getTitle(_vm.deliverable.contacts)
                    }
                  },
                  [
                    index < 3
                      ? _c("span", { staticClass: "exclude-outside-click" }, [
                          _vm._v(
                            _vm._s(_vm._f("textInitials")(fieldValue.name))
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    index == 3
                      ? _c("span", { staticClass: "exclude-outside-click" }, [
                          _vm._v(
                            "+" +
                              _vm._s(_vm.deliverable.contacts.length - index)
                          )
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e()
          }),
          _vm._v(" "),
          !_vm.deliverable.contacts.length
            ? _c(
                "span",
                { staticClass: "badge badge-gray exclude-outside-click" },
                [
                  _vm._v(
                    "No " +
                      _vm._s(
                        _vm.deliverableContactsLabel(
                          _vm.deliverable.deliverable_template_id
                        )
                      )
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("plus-button", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.addContactFlag,
                expression: "!addContactFlag"
              }
            ],
            staticClass: "tagged-contacts plus-button plus-button--small"
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "multiselect",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.outside,
              expression: "outside"
            },
            {
              name: "show",
              rawName: "v-show",
              value: _vm.addContactFlag,
              expression: "addContactFlag"
            }
          ],
          ref: "deliverableListContacts",
          attrs: {
            "option-height": 120,
            "close-on-select": false,
            options: _vm.contacts,
            id: _vm.deliverable.id,
            taggable: true,
            multiple: true,
            "show-labels": false,
            searchable: true,
            "internal-search": false,
            customLabel: _vm.contactCustomLabel,
            "open-direction": _vm.isMobile() ? "bottom" : "",
            label: "name",
            "track-by": "id",
            "tag-placeholder": "Add a new contact"
          },
          on: {
            "search-change": _vm.onContactSearch,
            tag: _vm.createContact,
            close: function($event) {
              _vm.addContactFlag = false
            },
            open: function($event) {
              return _vm.onContactSearch(false)
            },
            input: function($event) {
              return _vm.addDeliverableContact({
                contactData: _vm.deliverable.contacts,
                deliverableId: _vm.deliverable.id
              })
            }
          },
          scopedSlots: _vm._u([
            {
              key: "option",
              fn: function(props) {
                return [
                  _c("div", { staticClass: "option__desc" }, [
                    props.option.isTag
                      ? _c("div", [
                          _vm._v("Add new contact "),
                          _c("strong", [_vm._v(_vm._s(props.option.label))])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    props.option.name
                      ? _c("div", { staticClass: "option__name" }, [
                          _vm._v(_vm._s(props.option.name) + " ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    props.option.company_name
                      ? _c("div", { staticClass: "option__company" }, [
                          _vm._v(_vm._s(props.option.company_name) + " ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    props.option.cell_phone
                      ? _c("div", { staticClass: "option__phone" }, [
                          _vm._v(_vm._s(props.option.cell_phone) + " ")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    props.option.email_address
                      ? _c("div", { staticClass: "option__email" }, [
                          _vm._v(_vm._s(props.option.email_address) + " ")
                        ])
                      : _vm._e()
                  ])
                ]
              }
            }
          ]),
          model: {
            value: _vm.deliverable.contacts,
            callback: function($$v) {
              _vm.$set(_vm.deliverable, "contacts", $$v)
            },
            expression: "deliverable.contacts"
          }
        },
        [
          _vm._v(" "),
          _c("template", { slot: "noOptions" }, [
            _vm._v("\n      Start typing to find contacts.\n    ")
          ]),
          _vm._v(" "),
          _c("template", { slot: "noResult" }, [_vm._v("\n       \n    ")])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }